<template>
	<div class="exercise">
		<div class="exercise-div">
			<div class="exercise-left div" style="width: 14.75rem !important;">
				<!-- <div class="header1"> -->
					<!-- <div class="title">本题时间</div> -->
					<!-- <div class="time">{{timecount}}</div> -->
				<!-- </div> -->
				<div class="center">
					<div class="title">考试试题</div>
					<div class="qlist">
						<div class="qlist-div" v-for="(item,index) in questionlist" :key="index" v-if="index <page*9 && index >= (page-1)*9">
							
							<span class="left" :class="number==index?'actiy':''">{{index+1}}</span>
							<span class="right">{{item.name}}</span>
							
						</div>
					
						<div class="block">
							<el-pagination
						    layout="prev, pager, next"
							@current-change="currentChangeHandle"
							:current-page=page
						    :total="count">
							</el-pagination>
						</div>
						<div class="top">
							<div class="red"></div>
							<div class="white"></div>
							<div class="red"></div>
							<div>已完成</div>
						</div>
						
						
					</div>
				</div>
			</div>
			<div class="exercise-connet div" >
				<div class="exercise-connet-div">
					<div class="left">
						<div class="table1">
							<div class="table"  v-if="row==9">
								<img class="imgs2" :src="bagurl" />
								<!-- <div class="table-div" v-for="(item,index) in questioninfo.body" :key="index">
									<div class="table-div-div" v-for="(twoitem,two) in item" :key="two">
										<div class="table-div-div-input " v-for="(threeitem,three) in twoitem" :key="three" :class="typeactiy==index+two+three ? 'actiy':'' ">
											<input 
												type="text" 
												v-if="threeitem.type==0" 
												disabled
												class="inputdisabled"
												v-model="threeitem.number"
												:style="{'background':threeitem.templateColor}"   />
											<input type="text" 
												@change="wactchNum($event,index,two,three,1)"
												@click="typeactiyClick(index,two,three)"
												v-model="threeitem.number"
												:class="typeactiy==index+two+three ? 'actiy':'' "
											    v-else
												:style="{'background':threeitem.templateColor}"  />
										</div>
										
									</div>
								</div> -->
								<div class="tat9">
									<div class="table-div9" v-for="(item,index) in questioninfo.body" :key="index">
										<div class="table-div-div9" v-for="(twoitem,two) in item" :key="two">
											<div class="table-div-div-input9 " v-for="(threeitem,three) in twoitem" :key="three" :class="typeactiy==index+two+three ? 'actiy':'' ">
												<input
													type="number" 
													v-if="threeitem.type==0" 
													disabled
													class="inputdisabled"
													v-model="threeitem.number"
													:style="{'background':threeitem.templateColor}"   />
												<input type="number" 
													@change="wactchNum($event,index,two,three,1)"
													@click="typeactiyClick(index,two,three)"
													v-model="threeitem.number"
													maxlength ='1'
													:class="typeactiy==index+','+two+','+three+','+three  ? 'actiy':'' "
												    v-else
													:style="{'background':threeitem.templateColor}"  />
												
											</div>
											
										</div>
									</div>
									
								</div>
							</div>
							
							
							<div class="topic-body-input2"  style="margin-left: 0.625rem" v-if="row==6" >
								<img class="activebag5" :src="bagurl" />
								<div  class="topic-body-input-div2"  v-for="(item,index) in questioninfo.body" :key="index"  >
									<div class="topic-body-input-div-div" v-for="(twoitem,two) in item"
										 :key="two">
										<label v-for="(threeitem,three) in twoitem" :key="three">
											<input
												type="text" 
												v-if="threeitem.type==0" 
												disabled
												v-model="threeitem.number"
												:style="{'background':threeitem.templateColor}"   />
											<input type="text" 
												@change="wactchNum($event,index,two,three,1)"
												@click="typeactiyClick(index,two,three)"
												v-model="threeitem.number"
												
												:class="typeactiy==index+','+two+','+three+','+three  ? 'actiy':'' "
											    v-else
												:style="{'background':threeitem.templateColor}"  />
										</label>
									</div>
								</div>
							</div>
							
							<div class="topic-body-input1"   v-if="row==4" >
								<img class="activebag4" :src="bagurl" />
								<div  class="topic-body-input-div1"  v-for="(template,templateIndex) in questioninfo.body" :key="templateIndex"  >
								
										<div class="topic-body-input-div-div" v-for="(templates,templateIndexs) in template"
											 :key="templateIndexs">
											<label v-for="(templatess,templateIndexss) in templates" :key="templateIndexss"
														>
												<input
													type="text" 
													v-if="templatess.type==0" 
													disabled
													v-model="templatess.number"
													:style="{'background':templatess.templateColor}"   />
												<input type="text" 
													@change="wactchNum($event,templateIndex,templateIndexs,templateIndexss,1)"
													@click="typeactiyClick(templateIndex,templateIndexs,templateIndexss)"
													
													v-model="templatess.number"
													:class="typeactiy==templateIndex+','+templateIndexs+','+templateIndexss+','+templateIndexss  ? 'actiy':'' "
													v-else
													:style="{'background':templatess.templateColor}"  />
											</label>
										</div>
								</div>
							</div>
						</div>
					</div>
					<div class="right">
						<div class="title" v-if="touch==1">辅数触摸</div>
						<div class="assist" v-if="touch==1">
							<div v-for="(item,index) in assist"  :key="index" @click="touchArrClick(item)">{{item}}</div>
						</div>
					</div>
				</div>
				<div class="top">
					<div @click="resetClick()">清空 reset</div>
					<div @click="saveClick()">保存</div>
					<div @click="touchClick()">触摸 touch</div>
				</div>
			</div>
		</div>
		<div class="exercise-right"></div>
		<div class="middle">
			<div class="div">
				<div class="red" @click="submit()">提交本题</div>
				<div @click="upClick()">上一题</div>
				<div @click="belowClick()" class="red">下一题</div>
			</div>
			
		</div>
		
		<div class="analysis">
			<div class="title">
				<div class="bag"></div>
				<div class="title-div">{{questioninfo.name}}</div>
				<!-- <span class="span1">已经完成本题练习 </span> -->
				<!-- <span class="span2">用时1481秒</span> -->
			</div>
			<div class="connt" v-html="questioninfo.analysis">
			
			</div>
		</div>
		
		
		</div> 
	</div>
</template>

<script>
	export default {
		data() {
			return {
				game_id: '',
				questionlist : [],  //全部
				questioninfo : [],   //单条
				assist       : [1,2,3,4,5,6,7,8,9],
				page         : 1,
				count        : 2,
				touch        : 0,   //触摸
				typeactiy    : '',
				typeactiyarr : [],
				number       : 0,   //第几题
				start_time   : '',
				start_time1  : '',  //第一次进来的时间
				end_time     : '',
				info         : [],
				timecount    : '', //倒计时
				seconds      : 0, // 10天的秒数
				iscusscount  : 0,
				timestart    : '',
				tabtype      : 0,
				exerciselist : [],
				user         : [],
				row          : 9,
				bagurl       : ''
			}	
		},
		created() {
			var  query = this.$route.query;
			this.game_id = query.game_id;
			this.start_time  = this.start_time1 = new Date().getTime();
			this.getlist(query.game_id);
			this.time();
		},
	    methods: {
			tabtypeClick(e){
				this.tabtype  = e;
			},
			infoiscuss(id){
				let that = this;
				that.$http('get','/api/v1/iscuss/list',{type:2,three_id:id}) .then(function (res) {  //评论列表
					that.iscuss  = res.data.list;
					that.iscusscount  = res.data.count;
					console.log(res.data);
				});
			},
			currentChangeHandle(val) {
				let that = this;
				that.page = val;
				// that.getlist(that.classify_id);
			},
			touchClick(){   //触摸
				this.touch = this.touch==0 ? 1 : 0;
			},
			typeactiyClick(val, val1,val2){
					this.typeactiy	 = val+','+val1+','+val2+','+val2;
				this.typeactiyarr= [val,val1,val2];
			},
			touchArrClick(e){  //触摸输入
				let that  = this;
				var arr   = that.typeactiyarr;
				that.questioninfo['body'][arr[0]][arr[1]][arr[2]]['number'] = e;
				that.questioninfo['body'][arr[0]][arr[1]][arr[2]]['type'] = parseInt(1);
				console.log(that.questioninfo);
			},
			wactchNum(e, val, val1,val2,type) {   //键盘输入
				let that = this;
				if(that.touchType==1) return;
				if(!e.target.value) return;
				that.questioninfo['body'][val][val1][val2]['number'] = parseInt(e.target.value);
				that.questioninfo['body'][val][val1][val2]['type'] = parseInt(type);
				that.questionlist[that.number] = that.questioninfo;
				console.log(that.questioninfo['body']);
			},
			upClick(){  //上一题
				let that = this;
				if(that.number==0){
					that.$message({showClose: true,message: '已经是第一题',type: 'warning'});return;
				}
				async function testAsync() {
				    that.end_time  = new Date().getTime();
				    await that.$http('post','/api/v1/question/answer',{questioninfo:that.questioninfo}) .then(function (res) {  //计算分数
				    	that.questioninfo.start_time = that.start_time;
				    	that.questioninfo.end_time   = that.end_time;
				    	that.questioninfo.grade      = res.data;
				    	that.questionlist[that.number] = that.questioninfo;
						that.row    = that.questioninfo['template']['row'];
						that.bagurl = that.questioninfo['template']['img'];
				    });
				}
				testAsync();
				that.number = that.number  - 1;
				that.questioninfo = that.questionlist[that.number];
			},
			belowClick(){  //下一题
				let that = this;
				console.log(that.questionlist.length );
				if(that.number ==that.questionlist.length-1){
					that.$message({showClose: true,message: '已经是最后一题',type: 'warning'});return;
				}else{
					async function testAsync() {
					    that.end_time  = new Date().getTime();
					    await that.$http('post','/api/v1/question/answer',{questioninfo:that.questioninfo}) .then(function (res) {  //计算分数
					    	that.questioninfo.start_time = that.start_time;
					    	that.questioninfo.end_time   = that.end_time;
					    	that.questioninfo.grade      = res.data;
					    	that.questionlist[that.number] = that.questioninfo;
							that.start_time  = new Date().getTime();
							that.number = that.number  + 1;
							that.questioninfo = that.questionlist[that.number];
							if(that.number==that.page*9){
								that.page +=1;
							}
							that.row    = that.questioninfo['template']['row'];
							that.bagurl = that.questioninfo['template']['img'];
					    });
					}
					testAsync();
				}
			},
			resetClick(){  //清空reset
				let that = this;
				this.$confirm('清空后当前题目填写答案不再保留，谨慎操作', '确认清空吗', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(() => {
					   that.typeactiy    = '';
					   that.typeactiyarr = [];
					   that.getlist(that.classify_id);
					});
			},
			submit(){ //提交
				let that = this;
				async function testAsync() {
					that.end_time  = new Date().getTime();
					await that.$http('post','/api/v1/question/answer',{questioninfo:that.questioninfo}) .then(function (res) {  //计算分数
						that.questioninfo.start_time = that.start_time;
						that.questioninfo.end_time   = that.end_time;
						that.questioninfo.grade      = res.data;
						that.questionlist[that.number] = that.questioninfo;
						that.$http('post','/api/v1/question/addss',{topicList:JSON.stringify(that.questionlist),game_id:that.game_id,start_time:that.start_time1,end_time: new Date().getTime()}) .then(function (res) {  //联系方式
							if(res.code==200){
								localStorage.removeItem(that.classify_id+'number');
								localStorage.removeItem(that.classify_id+'questionlist');
								localStorage.removeItem(that.classify_id+'seconds');
								that.$message({message: res.msg,type: 'success'});
								that.$router.push('/exercise/details1?id='+res.data);	
							}
						});
					});
				}
				testAsync();
			},
			getlist(id){
				let that = this;
				that.$http('get','/api/v1/question/list',{game_id:id,page:1,size:100,lian:3}) .then(function (res) {  //
					that.questionlist = res.data.list;
					that.questionlist.forEach(item=>{
						item['start_time']  = '';
						item['end_time']  = '';
						item['grade']  = '';
					});
					that.count        = res.data.count+1;
					var classify_idnumber       = that.classify_id+'number';
					var classify_idquestionlist = that.classify_id+'questionlist';
					var classify_idSeconds      =   that.classify_id+'seconds';
					if(localStorage.getItem(classify_idquestionlist)){
						var json =JSON.parse(localStorage.getItem(classify_idquestionlist));
						var data2 = [];            // 某种意义上来说，数组也是object
						for (let i in json) {
							let o = {};
							o = json[i];
							data2.push(o)
						}
						that.questionlist   = data2;
						that.number         = localStorage.getItem(classify_idnumber) ? parseInt(localStorage.getItem(classify_idnumber)) : 0;
						that.seconds        = localStorage.getItem(classify_idSeconds) ? parseInt(localStorage.getItem(classify_idSeconds)) : that.seconds; 
					}
					that.questioninfo = that.questionlist[that.number];
					that.row          = that.questioninfo.template.row;
					that.bagurl       = that.questioninfo.template.img;
				});
				that.$http('get','/api/v1/classify/details',{id:id}) .then(function (res) {  //联系方式
					that.info = res.data.info;
					that.seconds = that.info.time * 60;
					console.log(that.seconds)
				
				});
				that.$http('get','/api/v1/question/exerciselist',{classify_id:id}) .then(function (res) {  //联系方式
					that.exerciselist = res.data.list;
				
					console.log(that.exerciselist);
				});
				that.$http('get','/api/v1/user/userinfos',{}) .then(function (res) {
					that.user  = res.data;
				});
			},
			saveClick(){
				let that = this;
				async function testAsync() {
				    that.end_time  = new Date().getTime();
				    await that.$http('post','/api/v1/question/answer',{questioninfo:that.questioninfo}) .then(function (res) {  //计算分数
				    	that.questioninfo.start_time = that.start_time;
				    	that.questioninfo.end_time   = that.end_time;
				    	that.questioninfo.grade      = res.data;
				    	that.questionlist[that.number] = that.questioninfo;
						localStorage.setItem(that.classify_id+'number',that.number);
						localStorage.setItem(that.classify_id+'questionlist',JSON.stringify(that.questionlist));
						localStorage.setItem(that.classify_id+'seconds',that.seconds);
						that.$message({message: '保存成功',type: 'success'});	
				    });
				}
				testAsync();
				
			},
			//定时器没过1秒参数减1
			time() {
				let that = this;
				
				that.timestart = setInterval(() => {
					that.seconds += 1
					that.countDown()
				}, 1000)
				
			},
			// 天 时 分 秒 格式化函数
			countDown() {
				let d = parseInt(this.seconds / (24 * 60 * 60))
				d = d < 10 ? "0" + d : d
				let h = parseInt(this.seconds / (60 * 60) % 24);
				h = h < 10 ? "0" + h : h
				let m = parseInt(this.seconds / 60 % 60);
				m = m < 10 ? "0" + m : m
				let s = parseInt(this.seconds % 60);
				s = s < 10 ? "0" + s : s
				this.timecount =  h + '时' + m + '分' + s + '秒'
			},
		},
		
		
	}	
</script>

<style lang="less">
	
	.exercise-connet-div {
		width: 38.75rem;
		height: 28.75rem;
		.left {
			flex: none;
			width: 25rem;
		}
		.right {
			flex: none;
			margin-left: 1.875rem;
			width: 20rem !important;
		}
	}
	.exercise > .exercise-div > .exercise-connet  > .top{
		width: none !important;
		display: flex ;
		margin: auto !important;
		margin-top:none !important;
	}
	@import  '../../../common/css/exercise.less';	
</style>
